import React, { Component } from 'react';
import './ec2ExMain.css';
import Ec2ExTableRow from './ec2ExTableRow/ec2ExTableRow.js';
import Ec2ExColumnControlPanel from './ec2ExColumnControlPanel/ec2ExColumnControlPanel.js';

class Ec2ExMain extends Component {

  state = {

  }

  componentDidUpdate() {

    if (document.getElementsByClassName('ColumnControls')[0]) {
      const columnControlsHeight = document.getElementsByClassName('ColumnControls')[0].clientHeight;
      document.documentElement.style.setProperty('--top-sticky-row-height', `${columnControlsHeight}px`);
    }

  }

  render() {

    return (
      <div className="Ec2ExMainPage">
        <table className="Ec2ExMainPageTable">
          <thead>
            <tr>
              <th className="StickyRowTop StickyColumn">Controls</th>
              {this.props.headers.slice(1).map(header => {
                return <Ec2ExColumnControlPanel
                  header={header}
                  key={`${header.title}-controls`}
                  toggleColumnVisibility={this.props.toggleColumnVisibility}
                  swapColumnOrder={this.props.swapColumnOrder}
                  sortColumn={this.props.sortColumn}
                />;
              })}
            </tr>
            <tr>
              {this.props.headers.map((header, index) => {
                return <th className={`StickyRowBottom${index < 1 ? ' StickyColumn' : ''}`} key={header.title}>{header.title}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {this.props.instances.map(instance => {
              return <Ec2ExTableRow
                key={instance.ReservedInstanceId}
                instance={instance}
                headers={this.props.headers}
                toggleHideRow={this.props.toggleHideRow}
                swapInstanceOrder={this.props.swapInstanceOrder}
              />;
            })}
          </tbody>
        </table>
      </div>
    );

  }

}

export default Ec2ExMain;


// WEBPACK FOOTER //
// ./src/components/content/ec2ResExplorer/ec2ExMain/ec2ExMain.js